export const adjustPaginationCount = (pagination, delta = 0) => {
  if (!pagination) return pagination;

  const items = Number(pagination.items) || 0;
  pagination.count = Math.max(0, (Number(pagination.count) || 0) + delta);
  pagination.pages = items > 0 ? Math.ceil(pagination.count / items) : 0;

  return pagination;
};

export const incrementPaginationCount = (pagination) => adjustPaginationCount(pagination, 1);

export const decrementPaginationCount = (pagination) => adjustPaginationCount(pagination, -1);
